module.exports = __webpack_public_path__ + "static/mission-img-7-b4ebf585e45d5166a8ba4346b3421bd9.jpg";